import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AlertService } from '@app/@core/services/alert.service';
import { PlatformSettingsService } from './@core/platform-settings.service';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { Timezone, TimezoneData } from '../@core/interface/interface';
import { LocalService } from '@core/services/local.service';
@Component({
  standalone: false,
  selector: 'app-platform-settings',
  templateUrl: './platform-settings.component.html',
  styleUrls: ['./platform-settings.component.scss']
})
export class PlatformSettingsComponent implements OnInit, OnDestroy {
  loginEvent$: BehaviorSubject<any>;
  orgId: any;
  userid = '';
  updateButton = false;
  configRegistrationForm: UntypedFormGroup;
  editConfigSettings: any;
  datetimeFomatList = [];
  tabErrorShow = false;
  public timezoneList: TimezoneData[] = [];
  private subscription = new Subscription();
  
  constructor(
    private alertService: AlertService,
    private _formBuilder: UntypedFormBuilder,
    private _platformSettingsService: PlatformSettingsService,
    private StorageService: LocalStorageService,
    private sessionStorage: LocalService
  ) {
    this.loginEvent$ = new BehaviorSubject<any>(null);
    this.userid = this.sessionStorage.getItem('id');
    this.orgId = this.sessionStorage.getItem('orgid');
  }

  ngOnInit(): void {
    this.initilizeForm();
    this.getConfigById();
    this.getDateTimeFormat();
    this.getTimezone();
  }
  initilizeForm() {
    this.configRegistrationForm = this._formBuilder.group({
      id: [''],
      datetimeformat: ['', Validators.required],
      timezone: ['', Validators.required]
    });
  }
  getDateTimeFormat() {
    this._platformSettingsService.getAllDatetimeFormatList().subscribe((result: any) => {
      this.datetimeFomatList = result.data;
    });
  }

  getTimezone(): void {
    this.subscription.add(
      this._platformSettingsService.getAllTimezoneList().subscribe({
        next: (result: Timezone) => {
          if(result.status === 'success') {
            this.timezoneList = result.data;
          }
        }
      })
    );
  }

  saveConfig() {
    this.tabErrorShow = true;
    if (this.configRegistrationForm.valid) {
      if (this.editConfigSettings) {
        this.editConfigSettings.organizationid = parseInt(this.editConfigSettings.organizationid, 10);
        this.editConfigSettings.layout = parseInt(this.editConfigSettings.layout, 10);
        this.editConfigSettings.datetimeformat = this.configRegistrationForm.value.datetimeformat;
        this.editConfigSettings.timezone = this.configRegistrationForm.value.timezone;
        this.updateButton = true;
        this._platformSettingsService
          .updateConfig(this.editConfigSettings.id, this.editConfigSettings)
          .subscribe(_res => {
            this.alertService.success('Updated successfully!');
            this.getConfigById();
          });
      } else {
        const inputRequest = {
          organizationid: parseInt(this.orgId, 10),
          datetimeformat: this.configRegistrationForm.value.datetimeformat,
          // timeout: this.configRegistrationForm.value.timeout
        };
        this.updateButton = true;
        this._platformSettingsService.saveConfigSettings(inputRequest).subscribe(_res => {
          this.alertService.success('Saved successfully!');
          this.getConfigById();
        });
      }
    }
  }

  getConfigById() {
    this._platformSettingsService.getConfigurationsByOrgId(this.orgId).subscribe((res: any) => {
      if (res.data) {
        this.updateButton = true;
        this.editConfigSettings = res.data;
        this.configRegistrationForm.patchValue({
          id: this.editConfigSettings.id,
          datetimeformat: this.editConfigSettings.datetimeformat,
          timeout: this.editConfigSettings.timeout || 30,
          timezone: this.editConfigSettings?.timezone
        });
        this.StorageService.setItem('REGISTRATION', this.editConfigSettings);
      } else {
        this.updateButton = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
